import { Box, Typography, Button, styled } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useState } from "react";
import InfoIcon from "@mui/icons-material/Info";
import color from "../../components/utils/Colors";
import { useDropzone } from "react-dropzone";
import { uploadCoverImage } from "../../services/services";
import { useSnackbar } from "../../components/utils/SnackBar";

const PhotoContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  marginTop: 20,
});

const CoverPicture = () => {
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const showSnackbar = useSnackbar();
  const [file, setFile] = useState<File | null>(null);
  const handleSave = async () => {
    try {
      if (!file) {
        showSnackbar("Please select an image first");
        return;
      }
      const formData = new FormData();
      formData.append("image", file);

      const response = await uploadCoverImage(formData);

      if (response?.data?.statusCode === 200) {
        showSnackbar(
          response?.data?.message || "Cover image uploaded successfully",
        );
      }
    } catch (error: any) {
      showSnackbar(
        error?.response?.data?.message || "Failed to upload cover image",
      );
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/*": [".jpeg", ".png", ".jpg"],
    },
    onDrop: (acceptedFiles) => {
      setFile(acceptedFiles[0]);
    },
  });

  return (
    <>
      <Box
        sx={(theme) => ({
          marginTop: "25px",
          flex: 1,
          p: "3%",
          borderRadius: "16px",
          bgcolor:
            theme.palette.mode === "light"
              ? "rgba(255, 255, 255, 0.4)"
              : "rgba(0, 0, 0, 0.4)",
          backdropFilter: "blur(2px)",
        })}
      >
        <Box
          sx={{
            flex: 1,
            p: 4,
            padding: isSmallScreen ? "0%" : "3%",
            pt: 0,
            paddingBottom: "10%",
          }}
        >
          <Box sx={{ borderRadius: "16px" }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{
                color: color.textColor,
                fontWeight: "bold",
                textAlign: "center",
                textDecoration: "underline",
                textUnderlineOffset: "4px",
                // color: "white",
                width: "fit-content",
                margin: "auto",
                padding: "4px 16px",
                borderRadius: "4px",
                mb: 4,
              }}
            >
              Edit Cover Photo
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                bgcolor: "transparent",
                boxShadow: "0px 4px 10px #00000010",
                borderRadius: 1,
                marginBottom: "35px",
                marginTop: "35px",
                height: "auto",
                paddingLeft: "0px",
              }}
            >
              <Box
                sx={{
                  bgcolor: color.firstColor,
                  borderRadius: "4px 0px 0px 4px",
                  p: 1,
                  paddingTop: 1.5,
                  paddingBottom: 1.5,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "auto",
                }}
              >
                <InfoIcon sx={{ color: "white" }} />
              </Box>
              <Typography sx={{ marginLeft: 2, fontSize: "14px" }}>
                Your cover photo will be used to customize the header of your
                profile.
              </Typography>
            </Box>

            <div>
              <div>
                <PhotoContainer>
                  <div style={{ width: "100%" }}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                      gap={2}
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        sx={{ m: 2, gap: 10, width: "100%" }}
                      >
                        {file && (
                          <Box mt={2}>
                            <Typography
                              sx={{
                                textAlign: "center",
                                fontWeight: "bold",
                                mb: 2,
                                p: 2,
                                borderRadius: "8px",
                                color: color.textColor,
                              }}
                              variant="body1"
                            >
                              Selected file Preview
                            </Typography>
                            <img
                              src={URL.createObjectURL(file)}
                              alt="Preview"
                              width={200}
                            />
                          </Box>
                        )}
                        <Box
                          sx={{
                            width: "100%",
                          }}
                        >
                          <Box
                            sx={{
                              color: "white",
                              borderRadius: "8px",
                              cursor: "pointer",
                              width: "80%",
                              alignSelf: "center",
                              margin: "auto",
                              // maxWidth: '700px',
                              alignItems: "center",
                              display: "flex",
                              justifyContent: "center",
                              mt: 0,
                            }}
                            {...getRootProps()}
                            border="1.5px dashed"
                            borderColor={color.borderColor}
                            padding={4}
                            // width={400}
                            height={250}
                          >
                            <input {...getInputProps()} />
                            <Typography
                              textAlign={"center"}
                              sx={{
                                p: 2,
                                fontSize: "18px",
                                borderRadius: "8px",
                                color: color.firstColor,
                              }}
                            >
                              Drag 'n' drop some files here or click to select
                              files
                            </Typography>
                          </Box>
                          <Typography
                                sx={{
                                  mt: 2,
                                  p: 2,
                                  borderRadius: "8px",
                                  color: color.textColor,
                                }}
                                border="2px solid"
                                borderColor={color.borderColor}
                                variant="body1"
                              >
                                Selected file:
                                {file && <> {file.name}</>}
                              </Typography>
                        </Box>
                      </Box>
                      <Button
                        onClick={handleSave}
                        id="button"
                        style={{
                          background: color.firstColor,
                          color: "white",
                          borderRadius: "8px",
                          marginTop: 20,
                        }}
                        color="primary"
                        disabled={!file}
                      >
                        Save
                      </Button>
                    </Box>
                  </div>
                </PhotoContainer>
              </div>
            </div>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CoverPicture;
